import script from "./ProjectsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsLayout.vue?vue&type=style&index=0&id=37e05653&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e05653"]])

export default __exports__